const Config = {
  // apiBaseUrl: "http://127.0.0.1:5000/",
  apiBaseUrl: "https://api.dev.mybucketlist.travelmagazine.com/",
};

export default Config;
